export default class ContactConsumptionsComponentController {

    constructor($scope, $injector) {
        this.scope = $scope;
        this.injector = $injector;
        this.api = this.injector.get('$http');
        this.userStore = this.injector.get('Users');

        this.loading = true;
        this.error = false;
        this.currentData = [];
        this.currentYearIndex = 0;

        this._initWatchers();
        this._initSettings();
    }

    _initSettings(){
        this.consumptionsEnabled = _.get(this.userStore, 'state.company.settings.contacts.enable_consumptions', false);
        this.showTip = _.get(this.userStore, 'state.company.settings.contacts.show_consumption_tip', false);
    }

    _initWatchers() {
        this.scope.$watch(() => {
            return this.contactId;
        }, (newVal) => {
            this._updateData();
        });
    }

    _updateData() {
        this.loading = true;
        this.currentData = [];
        this.currentYearIndex = 0;

        if (!this.contactId) {
            return;
        }

        this.api.post(`fp/contacts/${this.contactId}/consumptions`, {
            fields: [
                'amount',
                'amount_per_person',
                'tip',
                'tip_per_person',
                'year',
                'category',
                'shift.label',
                'shift.id'
            ],
            sort: {
                'year': 'asc',
                'shift.id': 'asc'
            }
        }).then((response) => {
            this.currentData = this._prepareDataFromFpResponse(response.data.data);
            this.currentYearIndex = this.currentData.length - 1;
            this.loading = false;
        }, () => {
            this.error = true;
            this.loading = false;
        })
    }

    /**
     *
     * @private
     * @return unknown[]
     * @param data
     */
    _prepareDataFromFpResponse(data) {
        const grouped = {};

        _.each(data, (v) => {
            if (_.isUndefined(grouped[v.year])) {
                grouped[v.year] = {
                    year: v.year,
                    full_year: null,
                    shifts: []
                }
            }

            if (_.isNull(v.shift.id)) {
                grouped[v.year].full_year = v;
            } else {
                grouped[v.year].shifts.push(v);

                grouped[v.year].shifts.sort(function (a, b) {
                    return a.shift.id - b.shift.id;
                });
            }
        });

        const out = Object.values(grouped);

        out.sort(function (a, b) {
            return a.year - b.year;
        });

        return out;
    }
}

ContactConsumptionsComponentController.$inject = [
    '$scope',
    '$injector'
];



// WEBPACK FOOTER //
// ./src/app/modules/contacts/components/contact-consumptions/controller.js